import { Formik } from 'formik'
import React, { FC } from 'react'

import { SigninFormMode, SSO_URL } from '@const/consts'

import SSOAuthForm from './components/SSOAuthForm'

import validationSchema from './validationSchema'

import { ISSOAuthProps as IProps, ISSOAuthValues } from './types'
import urls from '@const/urls'

const SSOAuth: FC<IProps> = ({ onSetMode }) => {
  const initialValues: ISSOAuthValues = {
    oguid: ''
  }

  const handleEmailLoginClick = (): void => {
    onSetMode(SigninFormMode.EMAIL)
  }

  const handlePhoneLoginClick = (): void => {
    onSetMode(SigninFormMode.PHONE)
  }

  const handleSubmit = ({ oguid }: ISSOAuthValues): void => {
    const url = `${SSO_URL}${urls.users.SSOFederations.replace('{{ oguid }}', oguid)}`

    window.location.href = url
  }

  return (
    <Formik
      enableReinitialize
      initialValues={initialValues}
      onSubmit={handleSubmit}
      validateOnChange
      validateOnBlur={false}
      validationSchema={validationSchema}
      validateOnMount
    >
      {(props) => (
        <SSOAuthForm
          {...props}
          onEmailLoginClick={handleEmailLoginClick}
          onPhoneLoginClick={handlePhoneLoginClick}
        />
      )}
    </Formik>
  )
}

export default SSOAuth
